"use strict";function o(o){return o&&"object"==typeof o&&"default"in o?o:{default:o}}var i=o(require("styled-components")).default.section`
    > ul {
        list-style: none;
        margin: 0;
        padding: 30px 0 0;
        display: grid;
        grid-row-gap: 33px;

        > li {
            margin: 0;
            padding: 0;
            position: relative;
            opacity: 0.5;
            transition: all 0.4s ease-in-out;

            &.open {
                opacity: 1;
            }

            > button {
                background: transparent;
                border: none;
                text-align: left;
                width: 100%;
                box-sizing: border-box;
                padding: 0;
                margin: 0;
                display: grid;
                grid-template-columns: 54px minmax(0, 1fr);
                grid-column-gap: 19px;
                cursor: pointer;

                > .icon {
                    width: 54px;
                    height: 54px;
                    position: relative;
                    color: ${({theme:o})=>o.colors.primary.light};
                    border-radius: 9px;
                    position: relative;
                    border-radius: 9px;
                    overflow: hidden;
                    padding: 9px;
                    box-sizing: border-box;
                    transition: color 0.4s ease-in-out;
                    &::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        background-color: ${({color:o})=>o};
                        transition: background-color 0.4s ease-in-out;
                    }
                }

                > .content {
                    > h3 {
                        margin: 15px 0 7px;
                    }

                    > .children {
                        overflow: hidden;
                        transition: all 0.4s ease-in-out;

                        > * {
                            &:first-child {
                                margin-top: 0;
                            }

                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }
                }
            }
        }
    }
`;module.exports=i;
//# sourceMappingURL=styles.js.map
